import React from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { AdminColors } from '../../../constants/adminColors';
import FontFamily from '../../../../../constants/fonts';

interface MoreAttributesButtonProps {
  label: string;
  onPress: () => void;
}

const MoreAttributesButton: React.FC<MoreAttributesButtonProps> = ({ label, onPress }) => {
  return (
    <TouchableOpacity style={styles.button} onPress={onPress} activeOpacity={0.8}>
      <Text style={styles.label}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingVertical: 6,
    height: 38,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: AdminColors.blue800,
    backgroundColor: AdminColors.bgSurface,
  },
  label: {
    fontSize: 11,
    fontWeight: '700',
    color: AdminColors.blue800,
    fontFamily: FontFamily.bold,
  },
});

export default MoreAttributesButton;